import { Grid, Text } from '@simplywallst/ui-core';

interface Props {
  height?: number;
}

export const DividendDefaultError = ({ height }: Props) => (
  <Grid padding="x2" height={height} alignItems="center">
    <Text as="span" typography="xSmall" color="textSolid">
      Something went wrong. Please try again.
    </Text>
  </Grid>
);
